var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',{staticClass:"top"},[_vm._v("抽選アプリ")]),_c('Member')],1)}
var staticRenderFns = []

export { render, staticRenderFns }